// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-bazar-js": () => import("./../../../src/pages/bazar.js" /* webpackChunkName: "component---src-pages-bazar-js" */),
  "component---src-pages-fama-js": () => import("./../../../src/pages/fama.js" /* webpackChunkName: "component---src-pages-fama-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-infantil-js": () => import("./../../../src/pages/infantil.js" /* webpackChunkName: "component---src-pages-infantil-js" */),
  "component---src-pages-success-js": () => import("./../../../src/pages/success.js" /* webpackChunkName: "component---src-pages-success-js" */)
}

